import { PropsWithChildren } from 'react'

import { StyledAuditEmail } from './styles'

interface EmailProps {
  address: string
  className?: string
}

const AuditEmail = ({
  address,
  children,
  className,
}: PropsWithChildren<EmailProps>) => (
  <StyledAuditEmail
    className={className}
    href={`mailto:${address}`}
    onClick={(evt) => evt.stopPropagation()}
  >
    {children}
  </StyledAuditEmail>
)

export default AuditEmail
